import React from 'react';
import i18n from 'i18n';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import Grid from '@material-ui/core/Grid';
import { Typography, makeStyles, useTheme } from '@material-ui/core';
import Loading from 'components/Loading';
import {
  SessionsHistoryMonitorGraphFields,
  PeriodCountAccess,
} from 'modules/monitor/interfaces';
import AutoCard from 'components/AutoCard';

import { setPeriodFilterInstances } from 'modules/monitor/actions';
import FilterSelector from 'components/FilterSelector';
import styles, { overrideCardGraph, overrideFilter } from './styles';
import InstancesHistoryCardContent from './InstancesHistoryCardContent';

export enum MonitorCardsEnum {
  environmentMissing = 'environmentMissing',
  environmentBlock = 'environmentBlock',
  instanceProblem = 'instanceProblem',
}

interface Props {
  isLoading: boolean;
  sessionsHistoryMonitorGraphFields: SessionsHistoryMonitorGraphFields;
  intervalTime: any;
  dateFilter: boolean;
  setPeriodFilterInstances: (prop: string) => void;
}

const IncidentsPanel = ({
  isLoading,
  sessionsHistoryMonitorGraphFields,
  intervalTime,
  dateFilter,
  setPeriodFilterInstances,
}: Props) => {
  const useStyles = makeStyles(styles);
  const classes = useStyles({});
  const { breakpoints } = useTheme();

  const filterPeriodOptions = () => [
    {
      id: 'last-24-hours',
      label: i18n.t(
        `ENVIRONMENT_DASHBOARD.LAST_${PeriodCountAccess.LAST_24_HOURS.toUpperCase()}`
      ),
      onClick: () => setPeriodFilterInstances(PeriodCountAccess.LAST_24_HOURS),
    },
    {
      id: 'last-48-hours',
      label: i18n.t(
        `ENVIRONMENT_DASHBOARD.LAST_${PeriodCountAccess.LAST_48_HOURS.toUpperCase()}`
      ),
      onClick: () => setPeriodFilterInstances(PeriodCountAccess.LAST_48_HOURS),
    },
    {
      id: 'last-7-days',
      label: i18n.t(
        `ENVIRONMENT_DASHBOARD.LAST_${PeriodCountAccess.LAST_7_DAYS.toUpperCase()}`
      ),
      onClick: () => setPeriodFilterInstances(PeriodCountAccess.LAST_7_DAYS),
    },
    {
      id: 'last-15-days',
      label: i18n.t(
        `ENVIRONMENT_DASHBOARD.LAST_${PeriodCountAccess.LAST_15_DAYS.toUpperCase()}`
      ),
      onClick: () => setPeriodFilterInstances(PeriodCountAccess.LAST_15_DAYS),
    },
    {
      id: 'last-30-days',
      label: i18n.t(
        `ENVIRONMENT_DASHBOARD.LAST_${PeriodCountAccess.LAST_30_DAYS.toUpperCase()}`
      ),
      onClick: () => setPeriodFilterInstances(PeriodCountAccess.LAST_30_DAYS),
    },
    {
      id: 'last-60-days',
      label: i18n.t(
        `ENVIRONMENT_DASHBOARD.LAST_${PeriodCountAccess.LAST_60_DAYS.toUpperCase()}`
      ),
      onClick: () => setPeriodFilterInstances(PeriodCountAccess.LAST_60_DAYS),
    },
  ];

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <Grid
          item
          xs={6}
          justify="center"
          alignContent="center"
          className={classes.pageBody}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} className={classes.graphCard}>
              <Grid container alignItems="center" justify="space-between">
                <Grid item>
                  <Typography className={classes.titleCard}>
                    {i18n.t('INSTANCES_HISTORY_GRAPH_KEY')}
                    {':'}
                  </Typography>
                </Grid>
                <Grid item>
                  {dateFilter && (
                    <FilterSelector
                      overrideClasses={overrideFilter}
                      options={filterPeriodOptions()}
                      currentValue={{
                        label: i18n.t(
                          `ENVIRONMENT_DASHBOARD.LAST_${intervalTime.toUpperCase()}`
                        ),
                        onClick: () => null,
                      }}
                    />
                  )}
                </Grid>
              </Grid>
              <AutoCard overrideClasses={overrideCardGraph(breakpoints)}>
                <Grid container className={classes.containerGraph}>
                  <InstancesHistoryCardContent
                    sessionsHistoryMonitorGraphFields={
                      sessionsHistoryMonitorGraphFields
                    }
                  />
                </Grid>
              </AutoCard>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
};

const mapStateToProps = ({
  monitor: {
    sessionsHistoryMonitorGraphFields,
    isLoading,
    periodFilterSessions,
  },
}: ApplicationState) => ({
  sessionsHistoryMonitorGraphFields,
  isLoading,
  intervalTime: periodFilterSessions,
});

export default connect(mapStateToProps, {
  setPeriodFilterInstances,
})(IncidentsPanel);
